<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-title">Table of Contents</h1>
<p class="section-break">––––––––</p>
<p style="text-align: justify; text-decoration: underline"><a href="#/c003#toc1">Forget Vacation</a></p>
<p style="text-align: justify; text-decoration: underline"><a href="#/c004#toc2">Belgian Mussels</a></p>
<p style="text-align: justify; text-decoration: underline"><a href="#/c005#toc3">Rejected Project</a></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c006#toc4" title="Link target outside of Sample">In A Children’s Playground</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c007#toc5" title="Link target outside of Sample">A Shirt with Style</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c008#toc6" title="Link target outside of Sample">Bread for the Ducks</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c009#toc7" title="Link target outside of Sample">A Straw-Colored Carpet</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c010#toc8" title="Link target outside of Sample">Turkish Lessons</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c011#toc9" title="Link target outside of Sample">Bulletin Board</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c012#toc10" title="Link target outside of Sample">A Waste Basket</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c013#toc11" title="Link target outside of Sample">Legal Counsel</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c014#toc12" title="Link target outside of Sample">An Underage Girl</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c015#toc13" title="Link target outside of Sample">The Raid</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c016#toc14" title="Link target outside of Sample">Working Relationships</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c017#toc15" title="Link target outside of Sample">A Case of Beer</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c018#toc16" title="Link target outside of Sample">An Urgent Warning</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c019#toc17" title="Link target outside of Sample">The Windmill</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c020#toc18" title="Link target outside of Sample">Family Honor</span></p>
<p style="text-align: justify; text-decoration: underline"><span href="#/c021#toc19" title="Link target outside of Sample">The Windmill Again</span></p>
<p style="font-weight: bold; page-break-before: always; text-align: center; text-indent: 0"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c002.vue?4220820c